import React from 'react';

interface IModalCommon {
  member: string;
  perms: string;
}

const ShareWithRow: React.FC<IModalCommon> = ({ member, perms }) => {
  return (
    <>
      <div className='activity-cont-frame-left-table-feed-row'>
        <div className='activity-cont-frame-left-table-feed-row-cont'>
          <div className='activity-cont-frame-left-table-feed-row-cont-col'>
            <div className='activity-cont-frame-left-table-feed-row-cont-col-text'>
              <div className='activity-cont-frame-left-table-feed-row-cont-col-text-left'>{member}</div>
              <div className='activity-cont-frame-left-table-feed-row-cont-col-text-right'>{perms}</div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareWithRow;
